import { RefObject } from 'react'

import { Box, InfiniteScroll, Spinner } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { EmployeeForSelectFragmentNoAccess } from 'modules/core/components/EntitySelectWrapper/Entities/Employees/types'

import ScheduleItem, { Item } from './ScheduleItem'
import { ScheduleRecordValuesType } from './ScheduleItem/types'

export type ScheduleParseDataType = {
  items: Item[]
  totalCount: number
}

interface BodyProps {
  loading: boolean
  parsedData: ScheduleParseDataType
  hasMore: boolean
  fetchMore: () => void
  range: [Date, Date]
  scrollContainerRef: RefObject<HTMLDivElement>
  openSidepanel: (
    data?: ScheduleRecordValuesType | null,
    employee?: EmployeeForSelectFragmentNoAccess | null
  ) => void
  isMyProjectsView?: boolean
}

const Body = ({
  loading,
  parsedData,
  hasMore,
  fetchMore,
  range,
  scrollContainerRef,
  openSidepanel,
  isMyProjectsView = false,
}: BodyProps) => {
  if (loading) {
    return (
      <Box height="full-view-height" width="full" justifyContent="center" alignItems="center">
        <Spinner />
      </Box>
    )
  }
  return (
    <InfiniteScroll
      hasMore={hasMore}
      loadMore={fetchMore}
      initialLoad={false}
      scrollContainerRef={scrollContainerRef}
    >
      {parsedData.items.map((item, index) => (
        <ScheduleItem
          key={index}
          item={item}
          startDate={moment(range[0])}
          endDate={moment(range[1])}
          openSidepanel={openSidepanel}
          isMyProjectsView={isMyProjectsView}
        />
      ))}
    </InfiniteScroll>
  )
}

export default Body
